var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCafeWhite1212 = function SvgCafeWhite1212(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.8 8.025c0 1.036.84 1.875 1.875 1.875H7.05c1.036 0 1.875-.84 1.875-1.875v-.94h1.074c.6 0 .801-.357.801-.85V2.672c0-.437-.4-.87-.856-.87H2.241a.44.44 0 0 0-.441.437zm7.125-5.063a.22.22 0 0 1 .22-.219h.634a.22.22 0 0 1 .22.22v3.054a.22.22 0 0 1-.22.219h-.634a.22.22 0 0 1-.22-.219z"
  })));
};
export default SvgCafeWhite1212;